export default "__VITE_ASSET__bf2a5192__"